import { Routes, Route, Navigate } from 'react-router-dom'
import { Toaster } from '@/components/ui/sonner'
import { AuthProvider } from '@/lib/auth-context'

// Pages
import LandingPage from '@/pages/landing'
import LoginPage from '@/pages/login'
import OnboardingPage from '@/pages/onboarding'
import ForgotPasswordPage from '@/pages/forgot-password'
import ResetPasswordPage from '@/pages/reset-password'
import StripeTrialPage from '@/pages/stripe-trial'
import DashboardLayout from '@/pages/dashboard/layout'
import DashboardHome from '@/pages/dashboard/home'
import InvestorsPage from '@/pages/dashboard/investors'
import DeckAnalyzerPage from '@/pages/dashboard/deck-analyzer'
import InvestorSearchPage from '@/pages/dashboard/investor-search'
import DealRoomPage from '@/pages/dashboard/deal-room'
import UpdatesPage from '@/pages/dashboard/updates'
import AnalyticsPage from '@/pages/dashboard/analytics'
import BillingPage from '@/pages/dashboard/billing'
import SettingsPage from '@/pages/dashboard/settings'
import CanvaCallbackPage from '@/pages/dashboard/canva-callback'

function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/onboarding" element={<OnboardingPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/stripe-trial" element={<StripeTrialPage />} />
        
        <Route path="/dashboard" element={<DashboardLayout />}>
          <Route index element={<DashboardHome />} />
          <Route path="investors" element={<InvestorsPage />} />
          <Route path="deck-analyzer" element={<DeckAnalyzerPage />} />
          <Route path="investor-search" element={<InvestorSearchPage />} />
          <Route path="deal-room" element={<DealRoomPage />} />
          <Route path="updates" element={<UpdatesPage />} />
          <Route path="analytics" element={<AnalyticsPage />} />
          <Route path="billing" element={<BillingPage />} />
          <Route path="settings" element={<SettingsPage />} />
          <Route path="canva-callback" element={<CanvaCallbackPage />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Toaster />
    </AuthProvider>
  )
}

export default App
